import { render } from "./deviceManage.vue?vue&type=template&id=6f5a189c&scoped=true"
import script from "./deviceManage.vue?vue&type=script&lang=js"
export * from "./deviceManage.vue?vue&type=script&lang=js"

import "./deviceManage.vue?vue&type=style&index=0&id=6f5a189c&lang=scss&scoped=scoped"
import "./deviceManage.vue?vue&type=style&index=1&id=6f5a189c&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5a189c"]])

export default __exports__